import { HeadingItem } from 'components';
import { TripContext } from 'contexts';
import React, { FC, useContext } from 'react';
import { ReasonClass } from 'services/enums';
import { CatchWeight, LineItem, Order, OrderItem, ReconcileReason } from 'services/types';
import './catch-weight-quantity-card.scss';

type Props = {
    item?: OrderItem,
    catchWeightItems?: CatchWeight[]
    stopId: number | undefined
    lineItemId: number
}

type CatchWeightItem = {
    deliveredQuantity: number | undefined,
    deliveredWeight: number | undefined,
    countedQuantity: number | undefined,
    countedWeight: number | undefined
}

export const CatchWeightQuantityCard: FC<Props> = ({ stopId, lineItemId }) => {
    const tripContext = useContext(TripContext)
    const orders: Order[] = tripContext.orders.filter(o => o.stopId == stopId)
    const lineItem: LineItem = tripContext.lineItems.find(li => li.id == lineItemId) ?? {} as LineItem
    const reconcileReasons: ReconcileReason[] = tripContext.reconcileReasons.toArray() ?? []

    let items: OrderItem[] = []
    let catchWeightItems: CatchWeight[] = []
    let item: OrderItem = items.length > 0 ? items[0] : {
        orderedQuantity: 0,
        shippedQuantity: 0,
        shippedWeight: 0
    } as OrderItem

    orders.forEach(order => {
        items = [...items, ...tripContext.orderItems.filter(oi => oi.orderId == order.id && oi.lineItemId == lineItemId)]
    })

    items.forEach(orderItem => {
        catchWeightItems = [...catchWeightItems, ...tripContext.catchWeights.filter(cw => cw.orderItemId == orderItem.id)]
        item.orderedQuantity += orderItem.orderedQuantity;
        item.shippedQuantity += orderItem.shippedQuantity;
        item.shippedWeight += orderItem.shippedWeight;
    })

    const getCountedItems = (): CatchWeight[] => catchWeightItems.filter(x => x.isVerified && (x.reconcileReasonId == null || reconcileReasons.some(reason => reason.id == x.reconcileReasonId && reason.class != ReasonClass.Shortage))) ?? []

    const getDeliveredItems = (): CatchWeight[] => getCountedItems().filter(x => x.reconcileReasonId == null || reconcileReasons.some(reason => reason.id == x.reconcileReasonId && reason.isRefusal == false))

    const calculateCountedQuantity = (): number => getCountedItems().length

    const calculateCountedWeight = (): number => getCountedItems().reduce((acc, x) => (acc + (x.adjustedWeight ? x.adjustedWeight : x.shippedWeight)), 0)

    const calculateDeliveredQuantity = (): number => getDeliveredItems().length

    const calculateDeliveredWeight = (): number => getDeliveredItems().reduce((acc, x) => acc + (x.adjustedWeight ? x.adjustedWeight : x.shippedWeight), 0)

    const order: Order = orders.length > 0 ? orders[0] : {} as Order


    let itemInfo: CatchWeightItem = {
        countedQuantity: calculateCountedQuantity(),
        countedWeight: +calculateCountedWeight().toFixed(3),
        deliveredQuantity: calculateDeliveredQuantity(),
        deliveredWeight: +calculateDeliveredWeight().toFixed(3)
    }

    return (
        <div className={'card-material'}>
            <HeadingItem text='Multiple POs' />
            <div className={'item-qty-card-details'}>
                <div>Ordered: {item.orderedQuantity}</div>
                <div>Shipped: {item.shippedQuantity}</div>
                <div>Lbs: {item.shippedWeight}</div>
                <div>UOM: {lineItem && lineItem.unitOfMeasure}</div>
            </div>
            <div className={'item-qty-card-sub-heading'}>
                <div style={{ width: '34%' }}></div>
                <div className={'item-qty-card-sub-heading-text'}>Quantity</div>
                <div className={'item-qty-card-sub-heading-text'}>Lbs</div>
            </div>
            <div className={'item-qty-card-row'}>
                <div className={'item-qty-card-adjusted-text'} style={{ width: '34%' }}>Counted</div>
                <div className={'item-qty-card-adjusted-text'}>{itemInfo.countedQuantity}</div>
                <div className={'item-qty-card-adjusted-text'}>{itemInfo.countedWeight}</div>
            </div>
            <div className={'item-qty-card-row'}>
                <div className={'item-qty-card-adjusted-text'} style={{ width: '34%' }}>Delivered</div>
                <div className={'item-qty-card-adjusted-text'}>{itemInfo.deliveredQuantity}</div>
                <div className={'item-qty-card-adjusted-text'}>{itemInfo.deliveredWeight}</div>
            </div>
        </div>
    )
}